import React from "react";
import BuscadorHotel from "../BuscadorHotel";

const SeccionIzquierda = () => {
  const estilos = {
    estilosDestinos: "col-sm-12",
    estilo1: "col-sm-12",
    estilosInputs: "col-sm-12",
    estilosInputFecha: "",
    estiloBoton: "col-sm-12",
    estiloEdadMenor: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12",
  };

  return (
    <aside className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
      <div className="filtros cdrColor">
        <BuscadorHotel estilos={estilos} isResultados />
      </div>
    </aside>
  );
};

export default SeccionIzquierda;



// WEBPACK FOOTER //
// ./src/components/Hoteles/ResultadosCdr/seccionIzquierda.js